import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Form, Button } from "react-bootstrap";
import { authServices } from "../APIServices/UserData/authServices";

const SetupPassword = ({
  setNextStep,
  setName,
  name,
  setEmail,
  email,
  setLoader,
  loader
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const setUpPassword = async () => {
    setLoader(true)
    let userData = {}
    userData.newPassword = newPassword
    userData.repeatPassword = confirmPassword
    userData.email = email
    userData.name = name
    let data = await authServices.setUpPassword(userData)
    if (data?.statusCode === 200) {
      setNextStep(data?.status)
      setName(data?.name)
      setEmail(data?.email)
      setNewPassword("")
      setConfirmPassword("")
    }
    setLoader(false)
  }
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Password</Form.Label>
        <div className="position-relative">
          <Form.Control
            onChange={(e) => setNewPassword(e.target.value)}
            value={newPassword}
            type={showPassword ? "text" : "password"}
            className="form-input"
            placeholder="Enter password"
          />
          <button
            type="button"
            className="btn-icon-show"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#999",
            }}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </button>
        </div>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Confirm Password</Form.Label>
        <div className="position-relative">
          <Form.Control
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
            type={showConfirmPassword ? "text" : "password"}
            className="form-input"
            placeholder="Confirm password"
          />
          <button
            type="button"
            className="btn-icon-show"
            onClick={() =>
              setShowConfirmPassword(!showConfirmPassword)
            }
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#999",
            }}
          >
            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
          </button>
        </div>
      </Form.Group>
      <div className="hstack gap-2">
        <Button
          onClick={setUpPassword}
          disabled={loader || !newPassword || !confirmPassword}
          className="w-100 btn-primary">
          Create Password
        </Button>
      </div>
    </>
  );
};

export default SetupPassword;
